import React, { useEffect, useMemo, useState } from "react";
import {
  FormFeedback,
  Input,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";

const InputText = ({
  input,
  label,
  type,
  className,
  placeholder,
  required,
  disabled,
  readonly,
  onClick,
  onKeyPress,
  style,
  invalid,
  appendText,
  wrapperStyle,
  maxLength,

  meta: { touched, error },
}) => {
  const [value, setValue] = useState(input.value);
  let isError = touched && typeof error !== "undefined";
  let requiredSpan = required && <span className="required">*</span>;
  if (readonly) {
    input.onChange = null;
  }
  useMemo(() => {
    setValue(input.value);
  }, [disabled, isError, requiredSpan, readonly, input.value]);

  const selectClass = className + " form-control";

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleBeforeInput = (e) => {
    if (e && e.nativeEvent && e.nativeEvent.inputType === "insertFromDrop") {
      e.preventDefault();
    }
  };

  return (
    <div style={wrapperStyle}>
      {label && (
        <label>
          {label} {requiredSpan}
        </label>
      )}
      <Input
        type={type}
        className={selectClass}
        placeholder={placeholder}
        invalid={invalid}
        disabled={disabled}
        readOnly={readonly}
        onClick={onClick}
        autoComplete="off"
        onKeyPress={onKeyPress}
        style={style}
        step="0.01"
        maxLength={maxLength}
        onFocus={(event) => {
          event.target.setAttribute("autocomplete", "off");
        }}
        {...input}
        name={input.name}
        onChange={(e) => {
          setValue(e.target.value);
          input.onChange(e);
        }}
        value={value}
        // 🔒 disable drag & drop
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onBeforeInput={handleBeforeInput}
      />
      {appendText && (
        <InputGroupAddon className="appendClass" addonType="append">
          <InputGroupText>{appendText}</InputGroupText>
        </InputGroupAddon>
      )}

      {isError && <FormFeedback>{error}</FormFeedback>}
    </div>
  );
};

export default InputText;



// WEBPACK FOOTER //
// ./src/components/InputText.js